<script setup lang="ts">
import { COLOR_PRIMARY } from '@/constants';
import AnyIcon from '@/core/elements/AnyIcon.vue';
import { EIcon } from 'common/enum/misc.enum';
import { computed } from 'vue';

type TPerformanceAssessmentIconSize = 'sm' | 'md' | 'lg';

const props = withDefaults(
  defineProps<{
    color?: string | null;
    size?: TPerformanceAssessmentIconSize;
    symbol: EIcon | string;
  }>(),
  {
    color: undefined,
    size: 'md',
  },
);

const sizeClass: Record<TPerformanceAssessmentIconSize, string> = {
  sm: 'size-icon-xs',
  md: 'size-icon-md',
  lg: 'size-button',
};

const resolvedColor = computed<string>(() => props.color ?? COLOR_PRIMARY);
</script>

<template>
  <AnyIcon
    aria-hidden="true"
    :icon-name="props.symbol"
    :class="['shrink-0', sizeClass[props.size]]"
    :style="{ color: resolvedColor }"
  />
</template>
